import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DtpTable,
  DtpTableHeader,
  DtpNoContent,
} from 'dtp-react-components';
import { ExportToCsv } from 'export-to-csv';
import {
  Button,
} from '../../components/index';
import {
  doPost,
} from '../../utils/requests';

const colunasRelatorioTotalizador = [
  'Solicitante',
  'Destinatário',
  'Criado',
  'Em exigência',
  'Alterado',
  'Aguardando análise',
  'Aguardando análise médico',
  'Em análise',
  'Em análise médico',
  'Deferido',
  'Análise suspensa',
  'Em compensação',
  'Aguardando compensação de aposentadoria',
  'Rejeitado',
  'Exigência / Indeferido',
  'Criado / Rejeitado',
  'Em conflito',
];

class NovoRelatorioTotalizadorEstados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
      legendaRelatorio: null,
    };
  }

gerarCsv = (lista) => {
  if (lista && lista !== undefined && lista.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'relatorio',
      fieldSeparator: ';',
      showTitle: true,
      title: this.state.legendaRelatorio,
      showLabels: true,
      headers: colunasRelatorioTotalizador,
    });
    csvExporter.generateCsv(lista);
  }
};

prepararColunasExportacao = (data) => {
  const dados = data.map((item) => {
    const linha = Object.assign({}, item);
    return linha;
  });
  return dados;
};

extrairColunasJson = (data) => {
  let objetoLinha = {};
  const dados = data.map((item) => {
    const objSolicitante = `${item[Object.keys(item)[1]]}-${item[Object.keys(item)[0]]}`;
    const objDestinatario = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
    objetoLinha = {
      solicitante: objSolicitante,
      destinatario: objDestinatario,
      criado: item[Object.keys(item)[4]],
      emExigencia: item[Object.keys(item)[5]],
      alterado: item[Object.keys(item)[6]],
      aguardandoAnalise: item[Object.keys(item)[7]],
      aguardandoAnaliseMedico: item[Object.keys(item)[8]],
      emAnalise: item[Object.keys(item)[9]],
      emAnaliseMedico: item[Object.keys(item)[10]],
      deferido: item[Object.keys(item)[11]],
      // indeferido: item[Object.keys(item)[12]],
      analiseSuspensa: item[Object.keys(item)[13]],
      emCompensacao: item[Object.keys(item)[14]],
      aguardandoCompensacaoAposentadoria: item[Object.keys(item)[16]],
      rejeitado: item[Object.keys(item)[17]],
      exigenciaIndeferido: item[Object.keys(item)[18]],
      criadoRejeitado: item[Object.keys(item)[20]],
      emConflito: item[Object.keys(item)[21]],
    };
    return objetoLinha;
  });
  return dados;
};

tratarSucessoListaExportacao = (response) => {
  if (response.data !== '') {
    const lista = this.extrairColunasJson(response.data);
    const dadosFormatados = this.prepararColunasExportacao(lista);
    this.setState({
    }, this.gerarCsv(dadosFormatados));
  }
};

tratarErro = () => {
  const mensagemPrimaria = 'Não foi possível consultar os requerimentos.';
  const mensagemSecundaria = 'Contate o administrador do sistema.';
  this.setState({
    showNoContent: true,
    noContentPrimaryMessage: mensagemPrimaria,
    noContentSecondaryMessage: mensagemSecundaria,
  });
};

preparaRequest = (url, parametros) => {
  doPost(
    url,
    parametros,
    this.tratarSucessoListaExportacao,
    this.tratarErro,
  );
};

exportarCsv = (props) => {
  this.setState({
    legendaRelatorio: props.legend,
  });
  if (props.urlExportacao && props.parametrosExportacao) {
    const parametros = props.parametrosExportacao;
    parametros['start-position'] = 0;
    parametros['max-results'] = 100000;
    this.preparaRequest(props.urlExportacao, parametros);
  }
};

render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      {this.props.nomeRelatorio !== '' ? (
        <React.Fragment>
          {this.props.data && this.props.data.length > 0 ? (
            <Button
              hint="Exportar para CSV"
              onClick={() => { this.exportarCsv(this.props); }}
              icon="ico-doc-sheet"
              mini
            />
          ) : ''}
          <div className="relatorio" style={{ '--relatorioWidth': this.props.containerStyle.width }}>
            <DtpTable {...this.props}>
              {this.props.headers.map((item, i) => (
                <DtpTableHeader
                  key={item}
                  dataField={this.props.data[0] ? Object.keys(this.props.data[0])[i] : 'default'}
                  dataAlign="center"
                  isKey={i === 0}
                  header={item}
                  tdStyle={{ wordBreak: 'break-word' }}
                  dataFormat={this.props.dataFormatOptions[i]}
                  hidden={this.props.options.hidden && this.props.options.hidden.includes(i)}
                />))}
            </DtpTable>
          </div>
        </React.Fragment>
      ) : null
      }
    </React.Fragment>
  );
}
}

NovoRelatorioTotalizadorEstados.propTypes = {
  dataFormatOptions: PropTypes.object,
}.isRequired;

NovoRelatorioTotalizadorEstados.defaultProps = {
  voltarAction: () => null,
};

export default NovoRelatorioTotalizadorEstados;



// WEBPACK FOOTER //
// ./src/pages/relatorios/NovoRelatorioTotalizadorEstados.jsx